export default __webpack_public_path__ + "static/media/bet1.b9bcd7c5.png";